export default {
    pack_crm: {
        label: window.i18n.__('utilisateurs'),
    },
    pack_invoicing_management: {
        label: window.i18n.__('Facturation'),
    },
    pack_prospecting_sale: {
        label: window.i18n.__('Vente'),
    },
    pack_all_included: {
        label: window.i18n.__('Vente & Facturation'),
    },
    pack_marketing_dedicated_ip: {
        label: window.i18n.__('Marketing: adresse IP dédiée'),
    },
    pack_marketing_custom_domain: {
        label: window.i18n.__('Marketing: délégation domaine'),
    },
    pack_marketing_email_business: {
        label: window.i18n.__('Email supplémentaires'),
    },
    pack_marketing_email_pro: {
        label: window.i18n.__('Email supplémentaires'),
    },
    pack_marketing_sms_business: {
        label: window.i18n.__('SMS supplémentaires'),
    },
    pack_marketing_sms_pro: {
        label: window.i18n.__('SMS supplémentaires'),
    },
    pack_marketing_multi_domains_auth: {
        label: window.i18n.__('Marketing: envoi multi-domaines'),
    },
    pack_invoicing: {
        label: window.i18n.__('Facturation'),
    },
    pack_management: {
        label: window.i18n.__('Pré-comptabilité'),
    },
    pack_stock: {
        label: window.i18n.__('Module Stock'),
    },
    pack_support: {
        label: window.i18n.__('Module Support'),
    },
    pack_marketing_starter: {
        label: window.i18n.__('Marketing Standard'),
        level: window.i18n.__('Standard'),
    },
    pack_marketing_pro: {
        label: window.i18n.__('Marketing Evolution'),
        level: window.i18n.__('Evolution'),
    },
    pack_marketing_business: {
        label: window.i18n.__('Marketing Elite'),
        level: window.i18n.__('Elite'),
    },
    pack_cashflow_starter: {
        label: window.i18n.__('Trésorerie Standard'),
        level: window.i18n.__('Standard'),
    },
    pack_cashflow_pro: {
        label: window.i18n.__('Trésorerie Evolution'),
        level: window.i18n.__('Evolution'),
    },
    pack_cashflow_business: {
        label: window.i18n.__('Trésorerie Elite'),
        level: window.i18n.__('Elite'),
    },
};
